import { Task } from './task';
import { StationType } from './station-type.enum';
import { ActionType } from './action-type.enum';
import { StationLevel } from './station-level.enum';
import { StationAssignmentStrategy } from '../../../../common/station-assignment-strategy/station-assignment-strategy.model';

export class RoutingRulePosition {
  id: number;
  index: number;
  stationId: number;
  stationName: string;
  stationType: StationType;
  actionType: ActionType;
  stationLevel: StationLevel;
  waitingForRetrieve: boolean;
  cargoMandatory: boolean;
  tasks: Task[] = [];
  deleted: boolean;
  predictedDuration: number;
  hint: string;
  processingStatusModel: string;
  stationAssignmentStrategy: StationAssignmentStrategy
}
